export default __webpack_public_path__ + "static/media/Strike Down.9975d885.png";